import { render, staticRenderFns } from "./StartSection.vue?vue&type=template&id=f80f8926&"
import script from "./StartSection.vue?vue&type=script&lang=js&"
export * from "./StartSection.vue?vue&type=script&lang=js&"
import style0 from "./StartSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports